import React, { useEffect, useState } from "react";

function MusicTimeLine(props) {
  const [duration, setDuration] = useState(0);
  useEffect(() => {
    setDuration(props.song.duration);
  }, [props]);
  return (
    <input
      type="range"
      min="0"
      max={duration}
      default="0"
      value={String(props.seconds)}
      className="timeline"
      onChange={(e) => props.setSeconds(Number(e.target.value))}
      disabled
    />
  );
}

export default MusicTimeLine;
